import React, { useEffect, useState } from "react";
import RaiseTicketsColumns from "./RaiseTicketsColumns";
import RaiseticketsCardsModal from "./RaiseticketsCardsModal";
import { getTickets, updateTicketSolution } from "../../../api";



const RaiseTicketsBoard =  ({ 
  issueType, 
  searchQuery,
  selectedDays 
}: { 
  issueType: string; 
  searchQuery: string;
  selectedDays: { startDate: string; endDate: string };
}) => {
  const [columns, setColumns] = useState<{ [key: string]: any[] }>({
    open: [],
    "In Progress": [],
    resolved: [],
  });
  const [selectedTask, setSelectedTask] = useState<{ ticket_id: string; title: string } | null>(null);

  
  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const response = await getTickets();
        
        if (!response || !response.data) {
          console.error("Invalid response format:", response);
          return;
        }
    
        const tickets = response.data; // Extract the actual ticket data from response
    
        // Transform tickets into columns based on status
        const updatedColumns: { [key: string]: any[] } = {
          open: [],
          "In Progress": [],
          resolved: [],
        };
    
        tickets.forEach((ticket: any) => {
          if (ticket.status && updatedColumns[ticket.status]) {
            updatedColumns[ticket.status].push(ticket);
          }
        });
    
        console.log("Updated Columns:", updatedColumns); // Debugging: Check if data is being assigned correctly
        setColumns(updatedColumns);
      } catch (error) {
        console.error("Error fetching tickets:", error);
      }
    };
    

    fetchTickets();
  }, []);

  
 const handleDragStart = (e: React.DragEvent, taskId: string, fromColumn: string) => {
  console.log("Dragging Task ID:", taskId);
  console.log("From Column:", fromColumn);
  
  e.dataTransfer.setData("taskId", taskId);
  e.dataTransfer.setData("fromColumn", fromColumn);
};

  const handleDrop = async (e: React.DragEvent, toColumn: string) => {
  e.preventDefault();
  const taskId = e.dataTransfer.getData("taskId");
  const fromColumn = e.dataTransfer.getData("fromColumn");

  if (fromColumn === toColumn) return;

  setColumns((prevColumns) => {
    const task = prevColumns[fromColumn]?.find((t) => t.ticket_id.toString() === taskId);
    if (!task) return prevColumns;

    return {
      ...prevColumns,
      [fromColumn]: prevColumns[fromColumn].filter((t) => t.ticket_id.toString() !== taskId),
      [toColumn]: [...prevColumns[toColumn], { ...task, status: toColumn }],
    };
  });

  // If the modal is open for this task, update it
  if (selectedTask?.ticket_id === taskId) {
    setSelectedTask((prev) => (prev ? { ...prev, status: toColumn } : prev));
  }

  try {
    await updateTicketSolution(Number(taskId), toColumn, ""); // Assuming no solution update is needed
    console.log(`Ticket ${taskId} updated successfully to ${toColumn}`);
  } catch (error) {
    console.error(`Failed to update ticket ${taskId}:`, error);
  }
};


  const openModal = (task: {  ticket_id: string; title: string }) => {
    setSelectedTask(task);
  };

  const closeModal = () => {
    setSelectedTask(null);
  };

  const updateTaskStatus = (taskId: string, newStatus: string) => {
    setColumns((prevColumns) => {
      let taskToMove: any = null;
      let sourceColumn: string | null = null;
  
      // Find and remove the task from its current column
      const updatedColumns = Object.keys(prevColumns).reduce((acc, col) => {
        const filteredTasks = prevColumns[col].filter((task) => {
          if (task. ticket_id === taskId) {
            taskToMove = { ...task, status: newStatus };
            sourceColumn = col;
            return false; // Remove this task from the source column
          }
          return true;
        });
        acc[col] = filteredTasks;
        return acc;
      }, {} as typeof prevColumns);
  
      // If task was found, move it to the new column
      if (taskToMove) {
        updatedColumns[newStatus] = [...(updatedColumns[newStatus] || []), taskToMove];
      } else {
        console.error(`Task with ID ${taskId} not found in any column.`);
      }
  
      return updatedColumns;
    });
  
    // Update the selected task in the modal if necessary
     setSelectedTask((prevTask) =>
      prevTask?.ticket_id === taskId ? { ...prevTask, status: newStatus } : prevTask
    );
  };

  const isWithinDateRange = (ticketDate: string) => {
    if (!selectedDays.startDate || !selectedDays.endDate) return true;

    const ticketTimestamp = new Date(ticketDate).getTime();
    const startTimestamp = new Date(selectedDays.startDate).getTime();
    const endTimestamp = new Date(selectedDays.endDate).getTime();

    return ticketTimestamp >= startTimestamp && ticketTimestamp <= endTimestamp;
  };
  
  console.log("columns:", columns);
 
  return (
    <div style={{ display: "flex", gap: "1rem",justifyContent:'center'}}>
  {Object.entries(columns).map(([columnName, tasks]) => {
        const filteredTasks = tasks.filter((task) => {
          const matchesIssueType =
            issueType.toLowerCase() === "all" ||
            (task.issue && task.issue.toLowerCase() === issueType.toLowerCase());

          const matchesSearchQuery =
            searchQuery === "" ||
            task.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            task.ticket_id.toString().includes(searchQuery);

          const matchesDateRange = task.date ? isWithinDateRange(task.date) : true;

          return matchesIssueType && matchesSearchQuery && matchesDateRange;
        });

        return (
          <RaiseTicketsColumns
            key={columnName}
            name={columnName}
            tasks={filteredTasks}
            handleDrop={handleDrop}
            handleDragStart={handleDragStart}
            openModal={openModal}
          />
        );
      })}
      {/* Render the modal when a task is selected */}
      {selectedTask && <RaiseticketsCardsModal selectedTask={selectedTask} closeModal={closeModal} updateTaskStatus={updateTaskStatus} />}
    </div>
  );
};

export default RaiseTicketsBoard;